import user from '@/store/modules/vote/ranking/reward/user';
import participate from '@/store/modules/vote/ranking/reward/participate';
export default {
  namespaced: true,
  modules: {
    user,
    participate
  }
};
